import type { ReactNode } from "react";
import type { IconName } from "../../icons";

export interface MenuAction {
  label: string;
  icon?: IconName;
  onSelect: () => void;
  tone?: "default" | "danger";
  disabled?: boolean;
  hint?: string;
  selected?: boolean;
}

export type MenuEntry = MenuAction | "separator" | { heading: string } | { node: ReactNode };

export function isAction(entry: MenuEntry): entry is MenuAction {
  return typeof entry === "object" && "onSelect" in entry;
}

/** React key for an entry; entries have no ids, so the position keeps repeated labels apart. */
export function entryKey(entry: MenuEntry, index: number): string {
  if (entry === "separator") return `sep-${index}`;
  if (isAction(entry)) return `${entry.label}-${index}`;
  if ("heading" in entry) return `h-${index}`;
  return `n-${index}`;
}
